import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  loadedItem(event) {
    event.preventDefault();

    var focusField = this.inputTargets[0];
    focusField.focus();
  }
}
